Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "GroupSettings2378775691",
  {"root":"GroupSettings2378775691--root","autoContent":"GroupSettings2378775691--autoContent","noGap":"GroupSettings2378775691--noGap","switchBlock":"GroupSettings2378775691--switchBlock","editBlock":"GroupSettings2378775691--editBlock","title":"GroupSettings2378775691--title","bodyText":"GroupSettings2378775691--bodyText","labelText":"GroupSettings2378775691--labelText","smallCaption":"GroupSettings2378775691--smallCaption","symbolsCount":"GroupSettings2378775691--symbolsCount","rowGap":"20px","marginTop":"34px","TextColor":"color-5","MainTextColor":"--overridable"},
  "",
  2,
  "GroupSettings2378775691"
);

